// extracted by mini-css-extract-plugin
export default {"titulo":"style_titulo__U+U8A","accordion":"style_accordion__wGpuZ"};